import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type Visibility = 'private' | 'organization';

export interface VisibilityConfig {
  id: Visibility;
  label: string;
  ariaLabel: string;
  tooltip: string;
  icon: IconProp;
}

export const VISIBILITY_CONFIG: Record<Visibility, VisibilityConfig> = {
  private: {
    id: 'private',
    label: 'Private',
    ariaLabel: 'Private visibility',
    tooltip: 'Private',
    icon: ['fas', 'lock'],
  },
  organization: {
    id: 'organization',
    label: 'Organization',
    ariaLabel: 'Organization visibility',
    tooltip: 'Visible to your organization',
    icon: ['fas', 'globe'],
  },
};
